module.exports = __webpack_public_path__ + "img/lpqv.cb4b951c.png";